export default "__VITE_ASSET__TTIJZ3FS__"